import { RetreivedDamagedGoodDTO } from "app/shared/model/retreivedDamagedGoodDTO.models";

export interface Claim {
  claimNumber: string;
  status: string;
  providerLabel: string;
  retrievedDamagedGood: Array<RetreivedDamagedGoodDTO>;
  relayPoint?: string;
  trackingNumber?: string;
  benefitId: string;
  benefitLocked: boolean;
}

export const initialState: Claim = {
  claimNumber: '',
  status: '',
  providerLabel: '',
  trackingNumber: null,
  retrievedDamagedGood: [],
  benefitId: '',
  benefitLocked: null,
};

export type ClaimState = Readonly<Claim>;
